'use es6';

import { css } from 'styled-components';
export const microInputMixin = css(["display:inline-block;font-size:14px;height:25px;line-height:normal;padding-top:4px;padding-bottom:4px;width:", "px;"], ({
  width
}) => width);